var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2816 10.9999C14.2816 12.8149 12.8149 14.2816 10.9999 14.2816C9.18493 14.2816 7.71826 12.8149 7.71826 10.9999C7.71826 9.18493 9.18493 7.71826 10.9999 7.71826C12.8149 7.71826 14.2816 9.18493 14.2816 10.9999Z",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 18.5807C14.2357 18.5807 17.2515 16.6741 19.3507 13.3741C20.1757 12.0816 20.1757 9.90908 19.3507 8.61658C17.2515 5.31658 14.2357 3.40991 10.9999 3.40991C7.76402 3.40991 4.74819 5.31658 2.64902 8.61658C1.82402 9.90908 1.82402 12.0816 2.64902 13.3741C4.74819 16.6741 7.76402 18.5807 10.9999 18.5807Z",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.40572390092232ec9baeb5d4abf9f683.svg";
export { ForwardRef as ReactComponent };